import {
  SET_BUTTON_PROCESSING,
  RESET_BUTTON_PROCESSING,
  CLEAR_BUTTON_PROCESSING,
} from "../../constants/actionTypes";

const initialState = {
  isProcessingButton: false,
  buttonProcessing: [],
};

const buttonProcessingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BUTTON_PROCESSING:
      const setButtonId = action.payload;
      const currentButtonProcessing = state.buttonProcessing;
      if (!currentButtonProcessing.includes(setButtonId)){
        currentButtonProcessing.push(setButtonId)
      }
      return {
        ...state,
        isProcessingButton: true,
        buttonProcessing: currentButtonProcessing,
      };
    case CLEAR_BUTTON_PROCESSING:
      const clearButtonId = action.payload;
      const newButtonProcessing = state.buttonProcessing.filter((id) => id !== clearButtonId);
      const isProcessing = newButtonProcessing.length === 0 ? false : true;
      return {
        ...state,
        isProcessingButton: isProcessing,
        buttonProcessing: newButtonProcessing,
      };
    case RESET_BUTTON_PROCESSING:
      return {
        ...state,
        isProcessingButton: false,
        buttonProcessing: [],
      };
    default:
      return state;
  }
};

export default buttonProcessingReducer;
